import { jwtDecode, JwtPayload } from "jwt-decode"
import { logout } from "../logout/logout.use-case"
import { createAppAsyncThunk, Dependencies } from "core/src/store/store.types"
import SuperTokensLock from "browser-tabs-lock"
import { TokenKeys } from "etl/types"

const refreshLock = new SuperTokensLock()
let refreshingPromise: Promise<string | undefined> | null = null

const checkIfTokenIsExpired = (token: string) => {
	const jwt = jwtDecode<JwtPayload>(token)
	let beforeExp = jwt.exp! - Date.now() / 1000
	beforeExp = beforeExp < 0 ? 0 : beforeExp
	return beforeExp <= 300
}

const refreshToken = async (extra: Dependencies) => {
	if (localStorage.getItem(TokenKeys.AW_REFRESH_TOKEN) == null) {
		throw new Error("No refresh token")
	}

	if (refreshingPromise == null) {
		// eslint-disable-next-line no-async-promise-executor
		refreshingPromise = new Promise(async (resolve) => {
			// Try to acquire lock 10 times before giving up
			let retryCount = 0
			while (!(await refreshLock.acquireLock(TokenKeys.AW_REFRESH_TOKEN, 10000)) && retryCount < 10) {
				retryCount++
			}

			try {
				const awAuthTokenRefresh = await extra.localStorage.getItem(TokenKeys.AW_REFRESH_TOKEN);
				const res = await extra.awClient.refreshToken(awAuthTokenRefresh)
				extra.localStorage.setItem(TokenKeys.AW_TOKEN, res.data.token)
				extra.localStorage.setItem(TokenKeys.AW_REFRESH_TOKEN, res.data.refresh_token)
				resolve(res.data.token)
			} catch {
				// do nothing
			} finally {
				await refreshLock.releaseLock(TokenKeys.AW_REFRESH_TOKEN)
				refreshingPromise = null
			}
		})
	}
}

export const initAuth = createAppAsyncThunk<void, void>(
	"auth/initAuth",
	(_, { dispatch, extra }) => {
		const token = localStorage.getItem(TokenKeys.AW_TOKEN);

		if (token) {
			if (checkIfTokenIsExpired(token)) {
				refreshToken(extra).catch(() => {
					dispatch(logout())
				})
			}
		} else {
			dispatch(logout())
		}
	}, {
	condition: (_, { getState }) => {
		const { isAuthenticated } = getState().auth;
		if (!isAuthenticated) return false;
	}
})
